var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#EEF1FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0005 12C16.3805 12 14.2505 14.13 14.2505 16.75C14.2505 19.32 16.2605 21.4 18.8805 21.49C18.9605 21.48 19.0405 21.48 19.1005 21.49C19.1205 21.49 19.1305 21.49 19.1505 21.49C19.1605 21.49 19.1605 21.49 19.1705 21.49C21.7305 21.4 23.7405 19.32 23.7505 16.75C23.7505 14.13 21.6205 12 19.0005 12Z",
    fill: "#405EDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0804 24.15C21.2904 22.29 16.7404 22.29 13.9304 24.15C12.6604 25 11.9604 26.15 11.9604 27.38C11.9604 28.61 12.6604 29.75 13.9204 30.59C15.3204 31.53 17.1604 32 19.0004 32C20.8404 32 22.6804 31.53 24.0804 30.59C25.3404 29.74 26.0405 28.6 26.0405 27.36C26.0304 26.13 25.3404 24.99 24.0804 24.15Z",
    fill: "#405EDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9906 17.3401C30.1506 19.2801 28.7706 20.9801 26.8606 21.2101C26.8506 21.2101 26.8506 21.2101 26.8406 21.2101H26.8106C26.7506 21.2101 26.6906 21.2101 26.6406 21.2301C25.6706 21.2801 24.7806 20.9701 24.1106 20.4001C25.1406 19.4801 25.7306 18.1001 25.6106 16.6001C25.5406 15.7901 25.2606 15.0501 24.8406 14.4201C25.2206 14.2301 25.6606 14.1101 26.1106 14.0701C28.0706 13.9001 29.8206 15.3601 29.9906 17.3401Z",
    fill: "#405EDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.99 26.59C31.91 27.56 31.29 28.4 30.25 28.97C29.25 29.52 27.99 29.78 26.74 29.75C27.46 29.1 27.88 28.29 27.96 27.43C28.06 26.19 27.47 25 26.29 24.05C25.62 23.52 24.84 23.1 23.99 22.79C26.2 22.15 28.98 22.58 30.69 23.96C31.61 24.7 32.08 25.63 31.99 26.59Z",
    fill: "#405EDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2);
export default __webpack_public_path__ + "static/media/icons2.1f521868fc43dc0ab8a52e4764feac67.svg";
export { ForwardRef as ReactComponent };